var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideos = function SvgVideos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0D5284",
    d: "M28.908 7.197c1.707 0 3.092 1.397 3.092 3.121v18.56C32 30.603 30.615 32 28.908 32H3.092C1.385 32 0 30.602 0 28.879v-18.56c0-1.725 1.385-3.122 3.092-3.122Zm0 .814H3.092a2.296 2.296 0 0 0-2.285 2.307v18.56a2.296 2.296 0 0 0 2.285 2.308h25.816a2.296 2.296 0 0 0 2.285-2.307v-18.56a2.296 2.296 0 0 0-2.285-2.308M28.1 3.598v1.01H3.899v-1.01h24.202ZM24.759 0v1.01H7.24V0h17.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6D5E",
    d: "M13.369 14.011v11.174l7.783-5.587zm.806 1.579 5.585 4.008-5.585 4.009z"
  }))));
};
export default SvgVideos;